import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const descriptions = {
  '/': ['The living world behind the everyday. | Graph of Life', 'Jay Gutierrez is a network scientist and systems biologist connecting ecological research, knowledge graphs, AI, software and institutional strategy through Graph of Life.', '/media/tlb/hero-whale.webp'],
  '/films': ['The Living Backbone | Films by Jay Gutierrez', 'The cinematic expression of Jay Gutierrez’s scientific inquiry, combining recorded evidence, computational models, cartography, authored imagery and original sound.', '/media/tlb/whale-feeding.webp'],
  '/films/the-waters-we-share': ['The Waters We Share | The Living Backbone', 'What does a blue whale give the sea? A short film connecting a recorded journey with authored illustrations of feeding, nutrient return and whale-fall communities.', '/media/tlb/hero-whale.webp'],
};
const legacyTitles = { '/systems': 'Proof Library', '/scope': 'Scope a Dependency Exposure Review', '/about': 'Jayson Gutierrez', '/thesis': 'Nature Risk', '/methodology': 'The Method', '/knowledge': 'Graph Intelligence', '/blue-capital': 'Natural Capital', '/philosophy': 'The Wider Argument' };
const professionalDescription = 'Jay Gutierrez builds inspectable intelligence around ecological dependencies, bringing research, knowledge graphs, AI and software into consequential institutional questions.';

export const RouteMetadata = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const origin = process.env.REACT_APP_PUBLIC_SITE_URL;
    if (!origin) throw new Error('REACT_APP_PUBLIC_SITE_URL is required for canonical metadata');
    const canonical = new URL(pathname, origin).href;
    const [title, description, image] = descriptions[pathname] || [`${legacyTitles[pathname] || 'Graph of Life'} | Graph of Life`, professionalDescription, '/images/jay.jpg'];
    document.title = title;
    const meta = (key, content, property = false) => {
      const attribute = property ? 'property' : 'name';
      let node = document.head.querySelector(`meta[${attribute}="${key}"]`);
      if (!node) { node = document.createElement('meta'); node.setAttribute(attribute, key); document.head.appendChild(node); }
      node.content = content;
    };
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement('link'); link.rel = 'canonical'; document.head.appendChild(link); }
    link.href = canonical;
    meta('description', description);
    ['og:title', 'twitter:title'].forEach(key => meta(key, title, key.startsWith('og:')));
    ['og:description', 'twitter:description'].forEach(key => meta(key, description, key.startsWith('og:')));
    ['og:image', 'twitter:image'].forEach(key => meta(key, new URL(image, origin).href, key.startsWith('og:')));
    meta('og:url', canonical, true);
  }, [pathname]);
  return null;
};